import { createIntegration } from './integration/create-integration';

export default createIntegration();
